import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../Context/AuthContext';

interface PrivateRouteProps {
  children: React.ReactNode;
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ children }) => {
  const { isAuthenticated, isLoading } = useAuth();
  const location = useLocation();
  // Show a loading spinner while checking authentication status
  if (isLoading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        flexDirection: 'column'
      }}>
        <div style={{
          border: '4px solid #f3f3f3',
          borderTop: '4px solid #3498db',
          borderRadius: '50%',
          width: '40px',
          height: '40px',
          animation: 'spin 1s linear infinite',
        }} />
        <style>{`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}</style>
      </div>
    );
  }

  if (!isAuthenticated) {
    const currentUrl = location.pathname + location.search;
    const ProdProtect = currentUrl.includes("products-protected");
    const NewsProtect = currentUrl.includes("news-protected");
    const BusProtect = currentUrl.includes("investor-protected");

    if (ProdProtect || NewsProtect || BusProtect) {
      return <Navigate to="/need-permission" replace />;
    }
    return <Navigate to="/user-login" replace />;
  }

  return <>{children}</>;
};

export default PrivateRoute; 